import React, { useContext } from 'react';
import MarketGroupsError from '../MarketGroups/MarketGroupsError';
import PerformanceChart from '../PerformanceChart/PerformanceChart';
import Context from '../../contexts/MarketPerformanceContext';
import { LottieLoader } from '../../utilities/Loaders';

const InstrumentGroups = () => {
    const context = useContext(Context);
    const { loading, showError } = context.state;

    if (showError) {
        return <MarketGroupsError/>;
    }

    return (
        <div className="chart">
            { loading ? (
                <div className="chart-container">
                    <div className="empty d-table text-center w-100 py-5">
                        <div className="d-table-cell align-middle">
                            <LottieLoader message={ 'Loading graph' }/>
                        </div>
                    </div>
                </div>
            ) : (
                <PerformanceChart name="chart-instrument-performance" showVolume/>
            )}
        </div>
    );
};

export default InstrumentGroups;
